export const transformUrl = (url: string) => {
  // Replace 'app' with 'my' in the URL
  const transformedUrl = url.replace('://app.', '://my.');
  return transformedUrl;
}
